import { render, staticRenderFns } from "./institution.vue?vue&type=template&id=ef7cf234"
import script from "./institution.vue?vue&type=script&lang=js"
export * from "./institution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef7cf234')) {
      api.createRecord('ef7cf234', component.options)
    } else {
      api.reload('ef7cf234', component.options)
    }
    module.hot.accept("./institution.vue?vue&type=template&id=ef7cf234", function () {
      api.rerender('ef7cf234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/avatar/institution.vue"
export default component.exports